import React from 'react';
import { Navbar, NavbarBrand } from 'shards-react';
import { Link } from 'react-router-dom';
import mainLogo from '../../../assets/images/synop_logo.png';

const SidebarMainNavbar = ({ handleClick }) => {
	return (
		<div className='main-navbar position-sticky top-md-0'>
			<Navbar className='align-items-stretch bg-white flex-md-nowrap border-bottom p-0' type='light'>
				<NavbarBrand tag={Link} to='/' className='col m-0 px-0 navbar-brand'>
					<img id='main-logo' className='m-auto' src={mainLogo} alt='Synop 2.0' />
				</NavbarBrand>
				<i className='px-3 d-md-none d-lg-none pointer fas fa-chevron-left align-items-center border-left' onClick={handleClick} />
			</Navbar>
		</div>
	);
};

export default SidebarMainNavbar;
